import React from "react";
import { useTranslation } from "react-i18next";

const fileIconForType = (contentType = "") => {
    if (contentType.includes("image")) return "🖼️";
    if (contentType.includes("pdf")) return "📕";
    if (contentType.includes("zip") || contentType.includes("compressed")) return "🗜️";
    if (contentType.includes("spreadsheet") || contentType.includes("excel")) return "📊";
    if (contentType.includes("presentation")) return "📽️";
    if (contentType.includes("audio")) return "🎵";
    if (contentType.includes("video")) return "🎬";
    return "📄";
};

const fileBadgeForType = (contentType = "", fileName = "") => {
    if (contentType.includes("image")) return "image";
    if (contentType.includes("video")) return "video";
    if (contentType.includes("audio")) return "audio";
    if (contentType.includes("spreadsheet") || fileName.endsWith(".xls") || fileName.endsWith(".xlsx")) return "sheet";
    if (contentType.includes("presentation") || fileName.endsWith(".ppt") || fileName.endsWith(".pptx")) return "deck";
    if (contentType.includes("pdf")) return "pdf";
    if (contentType.includes("zip") || fileName.endsWith(".zip")) return "archive";
    return "document";
};

const formatFileSize = (bytes = 0) => {
    if (!bytes) return "0 B";
    const units = ["B", "KB", "MB", "GB", "TB"];
    const exponent = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
    const size = bytes / 1024 ** exponent;
    return `${size.toFixed(size >= 10 ? 0 : 1)} ${units[exponent]}`;
};

export default function BandFilesPanel({
    files,
    isUploading,
    onUpload,
    onDownload,
    onDelete,
    resolvePreviewUrl,
}) {
    const { t } = useTranslation();
    return (
        <div className="workspace-grid workspace-grid--files">
            <div className="workspace-files__controls">
                <label className="workspace-files__upload">
                    <input type="file" multiple onChange={onUpload} />
                    <span>{isUploading ? t("bandsPage.files.uploading") : t("bandsPage.files.upload")}</span>
                </label>
            </div>
            <div className="workspace-files__gallery">
                {files.map((file) => {
                    const previewSource = resolvePreviewUrl ? resolvePreviewUrl(file) : file.previewUrl;
                    const badge = t(`bandsPage.files.badges.${fileBadgeForType(file.contentType || "", file.fileName || "")}`);
                    return (
                        <article key={file.objectKey} className="workspace-filecard">
                            <div className="workspace-filecard__preview">
                                {previewSource ? (
                                    <img src={previewSource} alt={t("bandsPage.files.previewAlt", { name: file.fileName })} loading="lazy" />
                                ) : (
                                    <span className="workspace-filecard__icon" aria-hidden="true">
                                        {fileIconForType(file.contentType)}
                                    </span>
                                )}
                                <span className="workspace-filecard__badge">{badge}</span>
                            </div>
                            <header className="workspace-filecard__header">
                                <h3>{file.fileName}</h3>
                                <span>{formatFileSize(file.size)}</span>
                            </header>
                            <footer className="workspace-filecard__footer">
                                <button type="button" onClick={() => onDownload(file)}>{t("bandsPage.files.open")}</button>
                                <button type="button" onClick={() => onDelete(file)} className="is-danger">{t("bandsPage.files.remove")}</button>
                            </footer>
                        </article>
                    );
                })}
                {files.length === 0 && (
                    <div className="workspace-placeholder">
                        <p>{t("bandsPage.files.empty")}</p>
                    </div>
                )}
            </div>
        </div>
    );
}
